<!--
 * @Description: file content
 * @Author:
 * @Date: 2024-11-19 19:05:04
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-09-23 13:36:34
-->
<script lang="ts" setup>
// 系统 code
// ● meiye-v2：美业数据大脑
// ● np：全球新品
// ● amz：亚马逊数据洞察
// ● amzen：亚马逊数据洞察英文版
// ● npen：新品英文版
// ● touke：商家后台
// ● dssc：数选供应链
// ● tkapp：数美链APP
import { checkgeo, getAccessToken } from '@/api'
import { useLoginData } from '@/hooks/useLoginData'
import { setDomainToken } from '@/utils/domainToken'
import emitter, { events } from '@/event-bus'
import { SERVICE_CODE_URLS } from '@/constants/serviceCode'
// const dataLoginUrl = import.meta.env.VITE_APP_API_DATA_LOGIN_URL

const showSystemRenewalDialog = ref(false)
const loopCheckGeoTimer = ref()

const params = ref<any>({})

const systemNames = {
  rpt: '报告系统',
}

function getApplyTitle(params) {
  // 供应链相关
  if (['touke', 'dssc'].includes(params.code)) {
    return `咨询入驻 ${params.title || params.name}`
  }
  // 其他
  return `申请试用 ${params.title || params.name || systemNames[params.code]}`
}

emitter.on(events.showSystemRenewalDialog, (data?: any) => {
  console.log('data-----showSystemRenewalDialog', data)
  isNotExists.value = data?.errorType === 'NOT_EXISTS'
  isNoPermission.value = data?.errorType === 'FORBIDDEN'
  if ((isNotExists.value || isNoPermission.value) && (data.code === 'meiye-v2' || data.code === 'np' || data.code === 'ct')) {
    handleReportApply(data)
  } else {
    showSystemRenewalDialog.value = true
    console.log('showSystemRenewalDialog', data)
    params.value = data
  }
})

function onClose() {
  showSystemRenewalDialog.value = false
  // 初始化
  isNotExists.value = false
  isNoPermission.value = false
  isDeviceError.value = false
  errorMoreData.value = {}
  isAddressError.value = false
  codePastDue.value = false
  limitAddress.value = []
  isScanSuccess.value = false
  isSuccessAndAddressError.value = false
  geoCodeKey.value = ''
  //清除轮询
  loopCheckGeoTimer.value && clearTimeout(loopCheckGeoTimer.value)
}

// 未绑定
const isNotExists = ref(false)
// 没有权益
const isNoPermission = ref(false) // computed(() => props.data.errorType === 'FORBIDDEN')
// 设备异常
const isDeviceError = ref(false) // computed(() => props.data.errorType === 'DEVICE_ERROR')
// 地理位置异常
const isAddressError = ref(false)
// 扫码过期
const codePastDue = ref(false)
// 限制地理位置
const limitAddress = ref([])
// 扫码成功
const isScanSuccess = ref(false)
// 移动账号，地理位置错误，需要显示扫码成功
const isSuccessAndAddressError = ref(false)
// 异常账号信息
const errorMoreData = ref({})

// 二维码携带的key
const geoCodeKey = ref('')

/** 获取扫码结果 */
function checkGeoFun({ key = params.value.key }) {
  if (!showSystemRenewalDialog.value) {
    return
  }
  geoCodeKey.value = key
  checkgeo({ key, sysCode: params.value.code }).then((res) => {
    // 验证成功
    isScanSuccess.value = true
    if (res) {
      isSuccessAndAddressError.value = true
    }
  }).catch((error) => {
    if (error.resultCode === 'EXPIRED') {
      // 过期
      codePastDue.value = true
    } else if (error.resultCode === 'PARAM_ERROR') {
      // 没扫码，继续轮询
      loopCheckGeoTimer.value = setTimeout(() => {
        checkGeoFun({ key })
      }, 1000)
    } else if (error.resultCode === 'IP_ERROR') {
      // 地理位置限制
      isAddressError.value = true
      limitAddress.value = error.moreData.address
      errorMoreData.value = error?.moreData
    }
  })
}

// 点击进去系统
function toJump() {
  getAccessToken({ sysCode: params.value.code }).then((resp: any) => {
    if (['amz', 'amzen'].includes(params.value.code)) {
      // 亚马逊是外部系统，获取redirectUrl跳转
      setDomainToken(resp.homeToken)

      window.open(resp.redirectUrl)
    } else {
      setDomainToken(resp.token)

      // 内部系统跳转
      const url = params.value.redirectUrl ? `${resp.redirectUrl}?t=${resp.token}&next=${params.value.redirectUrl}&redirectUrl=${params.value.redirectUrl}` : `${resp.redirectUrl}?t=${resp.token}`
      window.open(url, '_blank')
    }
    onClose()
  }).catch((error) => {
    if (error.resultCode !== 'NOT_LOGIN') {
      alert('获取授权失败，请联系管理员')
    }
  })
}

const { init, getSystem } = useLoginData()

// 扫码过期，重新获取扫码结果
async function handlerLoginReset() {
  await init()
  // 重新走登录流程
  getSystem(params.value.code).then((res: any) => {
    if (res.stage === 0) {
      getAccessToken({ sysCode: params.value.code }).then((resp: any) => {
        if (['amz', 'amzen'].includes(params.value.code)) {
          // 亚马逊是外部系统，获取redirectUrl跳转
          window.open(resp.redirectUrl)
          setDomainToken(resp.homeToken)
        } else {
          // 内部系统跳转
          window.open(`${resp.redirectUrl}?t=${resp.token}`, '_blank')
          setDomainToken(resp.token)
        }
      }).catch((error) => {
        isNotExists.value = error.resultCode === 'NOT_EXISTS'
        isNoPermission.value = error.resultCode === 'FORBIDDEN'
        isDeviceError.value = error.resultCode === 'DEVICE_ERROR'
        errorMoreData.value = error?.moreData
      })
    } else if (res.stage === 1) {
      // 需校验地理位置
      codePastDue.value = false
      checkGeoFun({ key: res.key })
    }
  }).catch((error) => {
    // if (error.resultCode === 'NOT_EXISTS') {
    // 未绑定数据系统账号 --- 跳转联合登陆页
    // window.open(dataLoginUrl)
    // } else {
    isNotExists.value = error.resultCode === 'NOT_EXISTS'
    isNoPermission.value = error.resultCode === 'FORBIDDEN'
    isDeviceError.value = error.resultCode === 'DEVICE_ERROR'
    errorMoreData.value = error?.moreData
    // }
  })
}

watch(() => params.value, () => {
  isNotExists.value = params.value?.errorType === 'NOT_EXISTS'
  isNoPermission.value = params.value?.errorType === 'FORBIDDEN'
  isDeviceError.value = params.value?.errorType === 'DEVICE_ERROR'
  errorMoreData.value = params.value?.moreData
  if (params.value.verifyGeography && showSystemRenewalDialog.value) {
    geoCodeKey.value = params.value.key
    // 需要获取地理位置
    checkGeoFun({ key: params.value.key })
  }
})


const showReportIframe = ref(false)
const meiyeV2Src = 'https://materialdb.zhaoyl.com/fed/report/%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2%EF%BC%9A%E2%80%9C%E6%95%B0%E6%8D%AE%E5%A4%A7%E8%84%91%E2%80%9D%E5%BA%94%E7%94%A8%E5%9C%BA%E6%99%AF%E4%BB%8B%E7%BB%8D-2025.pdf'
const ctSrc = 'https://materialdb.zhaoyl.com/fed/report/%E3%80%90%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2%E3%80%91%E5%AE%A3%E7%A7%B0%E8%B6%8B%E5%8A%BF%E6%B4%9E%E5%AF%9F-%E4%BA%A7%E5%93%81%E4%BB%8B%E7%BB%8D_2.1.pdf'
const npSrc = 'https://materialdb.zhaoyl.com/fed/report/%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2%EF%BC%9A%E2%80%9C%E5%85%A8%E7%90%83%E6%96%B0%E5%93%81%E6%B4%9E%E5%AF%9F%E2%80%9D%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D-2025.pdf'
const amzSrc = ''
const reportSrc = 'https://materialdb.zhaoyl.com/fed/report/%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2%EF%BC%9A%E5%AE%9A%E5%88%B6%E6%8A%A5%E5%91%8A%E6%9C%8D%E5%8A%A1%E4%BB%8B%E7%BB%8D%EF%BC%88%E8%AF%A6%E7%BB%86%E6%A1%88%E4%BE%8B%E5%B1%95%E7%A4%BA%EF%BC%89-2025.pdf'
const marketSrc = 'https://materialdb.zhaoyl.com/fed/report/%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2%EF%BC%9A%E5%B8%82%E5%9C%BA%E5%9C%B0%E4%BD%8D%E7%A1%AE%E8%AE%A4%E6%9C%8D%E5%8A%A1%E6%96%B9%E6%A1%88%EF%BC%88%E6%89%80%E6%9C%89%E4%BC%81%E4%B8%9A%EF%BC%89.pdf'
const npenSrc = ''
const amzenSrc = ''
const reportIframeSrc = ref(reportSrc)
function handleReportApply(item) {
  showReportIframe.value = true
  const srcMap = {
    'meiye-v2': meiyeV2Src,
    ct: ctSrc,
    np: npSrc,
    amz: amzSrc,
    report: reportSrc,
    market: marketSrc,
    npen: npenSrc,
    amzen: amzenSrc,
  }
  reportIframeSrc.value = srcMap[item.code]
  // window.open('https://materialdb.zhaoyl.com/fed/report/%E7%BE%8E%E4%B8%9A%E9%A2%9C%E7%A9%B6%E9%99%A2%EF%BC%9A%E5%AE%9A%E5%88%B6%E6%8A%A5%E5%91%8A%E6%9C%8D%E5%8A%A1%E4%BB%8B%E7%BB%8D%EF%BC%88%E8%AF%A6%E7%BB%86%E6%A1%88%E4%BE%8B%E5%B1%95%E7%A4%BA%EF%BC%89-2025.pdf')
}
</script>

<template>
  <NModal v-model:show="showReportIframe">
    <div class="report-pdf-modal">
      <div class="close-btn" @click="showReportIframe = false" />
      <iframe :src="reportIframeSrc" frameborder="0" scrolling="no" class="iframe"
        style="width: 1000px; height: 80vh;" />
    </div>
  </NModal>
  <NModal v-model:show="showSystemRenewalDialog" :close-on-esc="false" :mask-closable="false">
    <div class="app-system-renewal">
      <div class="logo" />
      <div class="close" @click="onClose" />

      <!-- 订阅咨询 -->
      <!-- <template v-if="params.code === 'rpt'">
        <div class="title">
          订阅咨询
        </div>
        <div class="qrcode-wrap">
          <div class="qrcode" :style="{ backgroundImage: `url(${serviceCodeUrls.report}` }" />
        </div>
        <div class="sub-title">
          扫码联系专属客服
        </div>
      </template> -->
      <!-- 定制咨询报告 -->
      <!-- <template v-if="params.code === 'report'">
        <div class="title">
          定制咨询报告
        </div>
        <div class="qrcode-wrap">
          <div class="qrcode" :style="{ backgroundImage: `url(${serviceCodeUrls.report}` }" />
        </div>
        <div class="sub-title">
          扫码联系专属客服
        </div>
      </template> -->
      <!-- 续费 -->
      <template v-if="params.code === 'reneval'">
        <div class="title">
          续费咨询
        </div>
        <div class="qrcode-wrap">
          <div class="qrcode" :style="{ backgroundImage: `url(${SERVICE_CODE_URLS.reneval}` }" />
        </div>
        <div class="sub-title">
          扫码联系专属客服
        </div>
      </template>

      <!-- 定制咨询报告 -->
      <template v-else-if="params.code === 'tkapp'">
        <div class="title">
          扫一扫 下载APP
        </div>
        <div class="qrcode-wrap">
          <div class="qrcode" :style="{ backgroundImage: `url(${SERVICE_CODE_URLS[params.code]}` }" />
        </div>
      </template>

      <!-- 咨询入驻 商家后台 -->
      <template v-else-if="params.code === 'tuoke'">
        <div class="title">
          咨询入驻 {{ params.title || params.name }}
        </div>
        <div class="qrcode-wrap">
          <div class="qrcode" :style="{ backgroundImage: `url(${SERVICE_CODE_URLS.touke}` }" />
        </div>
        <div class="sub-title">
          扫码联系专属客服
        </div>
      </template>

      <!-- 咨询入驻 数选供应链 -->
      <template v-else>
        <!-- 申请试用 (未绑定数据系统账号) -->
        <div v-if="isNotExists" class="error-content">
          <div class="title">
            {{ getApplyTitle(params) }}
          </div>
          <div class="qrcode-wrap">
            <div class="qrcode" :style="{ backgroundImage: `url(${SERVICE_CODE_URLS[params.code]}` }" />
          </div>
          <div class="sub-title">
            扫码联系专属客服
          </div>
        </div>
        <div v-if="isNoPermission" class="error-content">
          <div class="title">
            {{ getApplyTitle(params) }}
          </div>
          <div class="qrcode-wrap">
            <div class="qrcode" :style="{ backgroundImage: `url(${SERVICE_CODE_URLS[params.code]}` }" />
          </div>
          <!-- <img class="qr-code mt-10px" :src="SERVICE_CODE_URLS[params.code] + '?t=' + Date.now()" alt=""> -->
          <div class="tip">
            扫码联系客服开通账号
          </div>
        </div>
        <div v-if="isDeviceError" class="error-content">
          <div class="lock-icon" />
          <div class="equipment-title !mb-[4px]">
            设备异常
          </div>
          <div class="lock-sub-title !mb-[12px]">
            <div class="flex items-center justify-center text-[#FF4080]">
              <div class="info-item">
                {{ errorMoreData?.userInfo?.corpName }}
              </div>
              <div class="info-item">
                {{ errorMoreData?.userInfo?.nickName }}
              </div>
              <div class="info-item">
                {{ errorMoreData?.userInfo?.phone }}
              </div>
            </div>
          </div>
          <div class="lock-block">
            <div>尊敬的用户，安全智能助手检测到设备异常，设备异常的可能情况如下：</div>
            <div class="reason">
              <span>1、更换了浏览器</span>
              <span>2、更换了电脑</span>
            </div>
            <div>请在上一次登录的电脑或浏览器上登录，如果依然没有解决，请联系人工客服或者专属数据顾问解锁。</div>
            <div class="phone-wrap">
              <div class="phone-icon" />
              <span>020-22316867</span>
              <span> | </span>
              <span>(86+) 186 2087 3418</span>
            </div>
          </div>
        </div>
        <div v-if="isAddressError" class="error-content">
          <div class="limit-icon" />
          <div class="equipment-title">
            该系统限定地理位置使用
          </div>
          <div class="lock-sub-title">
            <div class="mt-[4px] flex items-center justify-center text-[#FF4080]">
              <div class="info-item">
                {{ errorMoreData?.userInfo?.corpName }}
              </div>
              <div class="info-item">
                {{ errorMoreData?.userInfo?.nickName }}
              </div>
              <div class="info-item">
                {{ errorMoreData?.userInfo?.phone }}
              </div>
            </div>
          </div>
          <div class="sub-title mb-[16px]">
            请在此区域内使用
          </div>
          <div v-for="(item, index) in limitAddress" :key="index" class="location-item flex">
            <div class="location-icon" />
            <div class="flex-1">
              {{ item }}
            </div>
          </div>
        </div>
        <div v-if="!isAddressError && !isScanSuccess && params.verifyGeography" class="error-content">
          <div class="title mb-[31px]">
            登录验证
          </div>
          <div class="login-code">
            <div v-if="codePastDue" class="lose-efficacy" @click="handlerLoginReset">
              <p>二维码失效</p>
              <p>请重新登录</p>
            </div>
            <img class="code-img"
              :src="`/assistant/board/data/user/geocode?v=${Math.random()}&key=${encodeURIComponent(geoCodeKey)}&sysCode=${params.code}`">
          </div>
          <div class="tips flex items-center">
            <img class="tips-icon"
              src="data:image/jpeg;base64,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"
              alt="">
            请授权用户用微信扫码进行安全验证
          </div>
        </div>
        <div v-if="isScanSuccess" class="error-content">
          <div class="success-icon" />
          <div class="success-title">
            验证成功
          </div>
          <div v-if="isSuccessAndAddressError" class="sub-title sub-title-no-bg">
            尊敬的用户，检测到您未在限定地理位置登录，本系统您的账号为移动账号，可以正常使用。但是这将影响到您固定账号系统的使用
          </div>
          <button class="enter-btn button-gradient" @click="toJump">
            点击进入系统
          </button>
        </div>
      </template>
    </div>
  </NModal>
</template>

<style lang="scss" scoped>
.report-pdf-modal {
  height: calc(80vh + 30px);
  padding-top: 30px;
  position: relative;
  box-shadow: none;

  .close-btn {
    position: absolute;
    right: -24px;
    top: 0;
    width: 24px;
    height: 24px;
    background: url('./icons/pdf-modal-close-btn.png') no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}


.app-system-renewal {

  width: 500px;
  min-height: 345px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url('https://materialdb.zhaoyl.com/fed/app-system-renewal-bg.png');
  background-size: 100% auto;
  background-position: top;
  background-repeat: no-repeat;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 20px;

  .logo {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 100px;
    height: 32px;
    background-image: url('https://materialdb.zhaoyl.com/fed/app-system-renewal-logo.png');
    background-size: cover;
  }

  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 24px;
      height: 2px;
      background: #242f57;
      transform-origin: center;
      left: 50%;
      top: 50%;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg) scale(0.8);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg) scale(0.8);
    }
  }

  .title {
    line-height: 28px;
    font-size: 16px;
    font-weight: 600;
  }

  .qrcode-wrap {
    margin-top: 28px;
    width: 160px;
    height: 160px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #FFA4E6;
    padding: 4px;

    .qrcode {
      width: 100%;
      height: 100%;
      background: #F5F5F5;
      background-size: cover;
    }
  }

  .sub-title {
    margin-top: 16px;
    padding: 4px 12px;
    background: #F1F5FE;
    border-radius: 20px 20px 20px 20px;
    line-height: 28px;
    font-size: 12px;
    color: #425466;
    text-align: center;

    &.sub-title-no-bg {
      background: none;
    }
  }

}

.error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;

  .title {
    font-weight: 500;
    font-size: 16px;
    color: #242F57;
    line-height: 22px;
    margin-bottom: 8px;
  }

  .sub-title {
    margin-bottom: 28px;
    font-size: 12px;
    color: #425466;
    line-height: 17px;
  }

  .qr-code {
    width: 160px;
    height: 160px;
  }

  .tip {
    margin-top: 20px;
    padding: 7px 16px;
    background: #E8EFFD;
    border-radius: 90px;
    font-size: 12px;
    color: #425466;
    line-height: 17px;
  }

  .lock-icon {
    width: 100px;
    height: 100px;
    background: url('./icons/lock-icon.png') no-repeat;
    background-size: contain;
  }

  .lock-sub-title {
    margin-bottom: 8px;
    font-size: 12px;
    color: #425466;
    line-height: 17px;

    &>div {
      flex-wrap: wrap;
    }
  }

  .info-item {
    color: #FF4080;

    &+.info-item {
      padding-left: 17px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 3px;
        left: 8px;
        display: inline-block;
        width: 1px;
        height: 12px;
        background: #E5E5E5;
      }
    }
  }

  .equipment-title {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #242F57;
    line-height: 20px;
  }

  .lock-block {
    width: 416px;
    padding: 12px 16px;
    margin-bottom: 22px;
    background: #F0F4FF;
    border-radius: 8px;
    font-size: 12px;
    color: #425466;
    line-height: 17px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    .reason {
      font-weight: 600;
      color: #242F57;
      display: flex;
      gap: 20px;
    }

    .phone-wrap {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #4050FF;

      .phone-icon {
        width: 14px;
        height: 14px;
        background: url('./icons/phone-icon.png') no-repeat;
        background-size: contain;
      }
    }
  }

  .limit-icon {
    width: 100px;
    height: 100px;
    background: url('./icons/limit-icon.png') no-repeat;
    background-size: contain;
    margin-bottom: 8px;
  }

  .location-item {
    width: 350px;
    margin-bottom: 10px;
    padding: 11px 12px 12px;
    background: #F0F4FF;
    border-radius: 4px;
    font-size: 12px;
    color: #425466;
    line-height: 17px;

    .location-icon {
      width: 14px;
      height: 14px;
      margin: 1px 4px 0 0;
      background: url('./icons/location-icon.png') no-repeat;
      background-size: contain;
    }
  }

  .code-img {
    width: 160px;
    height: 160px;
  }

  .tips {
    font-size: 12px;
    color: #425466;
  }

  .tips-icon {
    width: 16px;
    height: 16px;
    background: url('./icons/scan-code.png') no-repeat;
    background-size: contain;
    margin-right: 8px;
  }

  .login-code {
    position: relative;
    width: 160px;
    height: 160px;
    margin-bottom: 24px;

    .lose-efficacy {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      cursor: pointer;

      p {
        width: 100%;
        color: #fff;
        font-size: 14px;
        text-align: center;
      }
    }
  }

  .success-icon {
    width: 80px;
    height: 80px;
    background: url('./icons/success.png') no-repeat;
    background-size: contain;
    margin-bottom: 8px;
  }

  .success-title {
    font-weight: 500;
    margin-bottom: 28px;
    font-size: 14px;
    color: #242F57;
    line-height: 20px;
  }

  .enter-btn {
    width: 179px;
    height: 32px;
    border-radius: 90px;
  }
}
</style>
